import React from 'react';

/** 权限过滤器 */
export default ({ children, ...parameter }) => {
    if (parameter && parameter.visible) {
        let ret = React.cloneElement(children, { ...parameter})
        return ret;
    } else {
        return ``;
    }
}
